/* eslint-disable no-shadow */

export enum PaymentLinkStatus {
	InProgress = 'in_progress',
	Completed = 'completed',
	Refunded = 'refunded',
	ChargebackPending = 'chargeback_pending',
	ChargebackAccepted = 'chargeback_accepted',
	ChargebackAdjustment = 'chargeback_adjustment',
	ChargePending = 'charge_pending',
	Cancelled = 'cancelled',
	Failed = 'failed',
}

export const PAYMENT_LINK_AWAITING_PAYMENT_STATUSES: PaymentLinkStatus[] = [
	PaymentLinkStatus.InProgress,
	PaymentLinkStatus.ChargePending,
];

export enum PaymentLinkType {
	DownPayment = 'downPayment',
	PrincipalPayment = 'principalPayment',
}

export enum PaymentMethodEnum {
	Digital = 'digital',
	Store = 'store',
	BankAccount = 'bank_account',
}
